var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVeprimeTeShpejta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14 14",
    style: {
      enableBackground: "new 0 0 14 14"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st2{clip-path:url(#SVGID_00000147906324344131930570000014488570219170190501_);}\r\n\t.st3{clip-path:url(#SVGID_00000107552461679824976830000014357178311467841469_);}\r\n\t.st4{fill:#F2F2F2;}\r\n\t.st5{fill:#BDB6B8;}\r\n\t.st6{fill:#1A1A1A;}\r\n\t.st7{fill:#ADA8AA;}\r\n\t.st8{fill:#262424;}\r\n\t.st9{fill:#1E8273;}\r\n\t.st10{fill:#239281;}\r\n\t.st11{fill:#262626;}\r\n\t.st12{fill:#0F0F0F;}\r\n\t.st13{fill:#212226;}\r\n\t.st14{opacity:0.25;}\r\n\t.st15{clip-path:url(#SVGID_00000174585392452820305140000006067061358250213544_);}\r\n\t.st16{opacity:0.15;}\r\n\t.st17{clip-path:url(#SVGID_00000103229546908714925890000000081585120116627867_);}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4186_00000130616742241989517700000005326030424168688534_",
    transform: "translate(2.222 2.479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7428_00000028307989207194211430000003663479962056332434_",
    className: "st0",
    d: "M2.8,0.3C1.8,1.6,0.9,3.1,0.2,4.6 l-1.6-0.7c-0.4-0.2-0.5-0.6-0.4-1c0-0.1,0.1-0.2,0.2-0.2l2.2-2.2C0.9,0.2,1.4,0,1.9,0.1L2.8,0.3L2.8,0.3z M3.9,7.7 C4.1,7.9,4.5,8,4.7,7.9c1.4-0.6,2.7-1.5,3.8-2.5c3.3-3.3,3.4-6.1,3.2-7.2c-0.1-0.3-0.3-0.5-0.6-0.6C10-2.6,7.3-2.6,3.9,0.8 c-1,1.1-1.9,2.4-2.5,3.8C1.3,4.9,1.4,5.2,1.6,5.4L3.9,7.7z M9,6.5C7.7,7.6,6.3,8.4,4.7,9.1l0.7,1.6c0.2,0.4,0.6,0.5,1,0.4 c0.1,0,0.2-0.1,0.2-0.2l2.2-2.2c0.3-0.3,0.5-0.8,0.4-1.3L9,6.5L9,6.5z M2.7,8.4c0.1,0.7-0.1,1.5-0.6,2c-1,0.6-2.2,1-3.4,1.2 c-0.4,0.1-0.8-0.2-0.9-0.6c0-0.1,0-0.2,0-0.3C-2,9.6-1.6,7.8-1,7.3c0.9-0.9,2.2-0.9,3.1,0C2.4,7.6,2.6,8,2.7,8.4L2.7,8.4z M5.6,2.3 c0-0.8,0.7-1.5,1.5-1.5c0.8,0,1.5,0.7,1.5,1.5S7.9,3.7,7.1,3.7C6.3,3.7,5.6,3.1,5.6,2.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVeprimeTeShpejta);
export default __webpack_public_path__ + "static/media/icon_veprime_te_shpejta.969998ae6a47cb5a3f74c68fe635b260.svg";
export { ForwardRef as ReactComponent };